export { PremiumFaq as AccordionFaq } from "../conversion-sections"
export type { PremiumFaqProps as AccordionFaqProps } from "../conversion-sections"